<div class="c-loading c-loading--{{ size }}">
  <img src="assets/img/loading.gif" alt="" />
</div>
